import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { create } from 'zustand';

// Cargar dato inicial del localStorage
const getInitialRoutines = () => {
  try {
    const stored = localStorage.getItem('fitnessData');
    if (!stored) return getDefaultRoutines();
    const data = JSON.parse(stored);
    return data.routines || getDefaultRoutines();
  } catch (e) {
    console.error('Error loading routines:', e);
    return getDefaultRoutines();
  }
};

const getDefaultRoutines = () => [
  {
    id: 'routineDefault1',
    name: 'Rutina 1: Push + Piernas (Cuádriceps) + Core',
    active: true,
    days: [
      {
        id: 'day1_pushlegs',
        name: 'Día 1 - Empuje + Piernas + Core',
        weekDays: ['lunes', 'jueves'],
        exercises: [
          // Piernas (Cuádriceps)
          { exerciseId: '29', sets: 3, reps: '10-12', order: 1, name: 'Sentadilla Goblet' },
          { exerciseId: '31', sets: 3, reps: '15-20', order: 2, name: 'Elevación de Talones' },
          // Pecho
          { exerciseId: '1', sets: 3, reps: '8-12', order: 3, name: 'Press de Banca' },
          { exerciseId: '3', sets: 3, reps: '12-15', order: 4, name: 'Aperturas' },
          // Hombros
          { exerciseId: '33', sets: 3, reps: '10-12', order: 5, name: 'Press de Hombros' },
          { exerciseId: '34', sets: 3, reps: '12-15', order: 6, name: 'Elevaciones Laterales' },
          // Tríceps
          { exerciseId: '35', sets: 3, reps: '10-12', order: 7, name: 'Extensiones de Tríceps' },
          { exerciseId: '36', sets: 3, reps: '12', order: 8, name: 'Press Francés' },
          // Abdominales
          { exerciseId: '40', sets: 3, reps: '15-20', order: 9, name: 'Crunch Abdominal' },
          { exerciseId: '41', sets: 3, reps: '30-60seg', order: 10, name: 'Plancha' },
        ],
      },
    ],
  },
  {
    id: 'routineDefault2',
    name: 'Rutina 2: Pull + Piernas (Isquiotibiales/Glúteos) + Core',
    active: true,
    days: [
      {
        id: 'day2_pulllegs',
        name: 'Rutina 2: Pull + Piernas (Isquiotibiales/Glúteos) + Core',
        weekDays: ['martes', 'viernes'],
        exercises: [
          // Piernas (Isquiotibiales/Glúteos)
          { exerciseId: '28', sets: 3, reps: '10-12', order: 1, name: 'Peso Muerto Rumano' },
          // Espalda
          { exerciseId: '26', sets: 3, reps: '10-12', order: 2, name: 'Remo Mancuerna a Una Mano' },
          { exerciseId: '27', sets: 3, reps: '12-15', order: 3, name: 'Pullover' },
          // Bíceps
          { exerciseId: '38', sets: 3, reps: '12', order: 4, name: 'Curl Barra W' },
          { exerciseId: '10', sets: 3, reps: '8-12', order: 5, name: 'Curl de Bíceps' },
          { exerciseId: '37', sets: 3, reps: '10-12', order: 6, name: 'Curl Martillo' },
          // Antebrazos
          { exerciseId: '39', sets: 3, reps: '15-20', order: 7, name: 'Curl de Muñeca' },
          // Core
          { exerciseId: '42', sets: 3, reps: '15-20', order: 8, name: 'Elevación de Piernas' },
        ],
      },
    ],
  },
  {
    id: 'routine1',
    name: 'Rutina 3: Push/Pull 4 Días',
    active: false,
    days: [
      {
        id: 'day1',
        name: 'Rutina 1 - Push',
        weekDays: ['lunes'],
        exercises: [
          { exerciseId: '1', sets: 4, reps: '6-8', order: 1 },
          { exerciseId: '2', sets: 4, reps: '8-10', order: 2 },
          { exerciseId: '3', sets: 3, reps: '10-12', order: 3 },
        ],
      },
      {
        id: 'day2',
        name: 'Rutina 2 - Pull',
        weekDays: ['martes'],
        exercises: [
          { exerciseId: '4', sets: 4, reps: '6-10', order: 1 },
          { exerciseId: '5', sets: 4, reps: '8-10', order: 2 },
          { exerciseId: '6', sets: 4, reps: '8-10', order: 3 },
        ],
      },
      {
        id: 'day3',
        name: 'Día 3 - Push',
        weekDays: ['jueves'],
        exercises: [
          { exerciseId: '1', sets: 4, reps: '6-8', order: 1 },
          { exerciseId: '11', sets: 3, reps: '10-12', order: 2 },
          { exerciseId: '3', sets: 3, reps: '12-15', order: 3 },
        ],
      },
      {
        id: 'day4',
        name: 'Día 4 - Piernas',
        weekDays: ['viernes'],
        exercises: [
          { exerciseId: '7', sets: 4, reps: '6-8', order: 1 },
          { exerciseId: '8', sets: 4, reps: '8-10', order: 2 },
          { exerciseId: '9', sets: 3, reps: '10-12', order: 3 },
        ],
      },
    ],
  },
];

// Helper para guardar en localStorage unificado
const saveToLocalStorage = (state) => {
  try {
    const current = localStorage.getItem('fitnessData');
    const allData = current ? JSON.parse(current) : {};
    allData.routines = state.routines;
    saveUtilityCache('fitnessData', allData);
  } catch (e) {
    console.error('Error saving routines:', e);
  }
};

export const useRoutineStore = create((set, get) => ({
  routines: getInitialRoutines(),

  createRoutine: (routine) =>
    set((state) => {
      const newState = {
        routines: [...state.routines, { id: Date.now().toString(), ...routine }],
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  updateRoutine: (id, updates) =>
    set((state) => {
      const newState = {
        routines: state.routines.map((r) => (r.id === id ? { ...r, ...updates } : r)),
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  deleteRoutine: (id) =>
    set((state) => {
      const newState = {
        routines: state.routines.filter((r) => r.id !== id),
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  duplicateRoutine: (id) =>
    set((state) => {
      const routine = state.routines.find((r) => r.id === id);
      if (!routine) return state;
      const duplicate = {
        ...routine,
        id: Date.now().toString(),
        name: `${routine.name} (Copia)`,
      };
      const newState = { routines: [...state.routines, duplicate] };
      saveToLocalStorage(newState);
      return newState;
    }),

  getRoutineById: (id) => get().routines.find((r) => r.id === id),

  getTodayName: () => {
    const daysOrder = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    return daysOrder[new Date().getDay()];
  },

  getTodayWorkout: () => {
    const today = get().getTodayName();
    const routines = get().routines.filter((r) => r.active);

    const todayWorkouts = [];
    routines.forEach((routine) => {
      routine.days.forEach((day) => {
        if (day.weekDays && day.weekDays.includes(today)) {
          todayWorkouts.push({
            routineId: routine.id,
            routineName: routine.name,
            day,
          });
        }
      });
    });
    return todayWorkouts;
  },

  getRoutinesByDay: (dayName) => {
    const routines = get().routines.filter((r) => r.active);
    const matches = [];
    routines.forEach((routine) => {
      routine.days.forEach((day) => {
        if (day.weekDays && day.weekDays.includes(dayName)) {
          matches.push({
            routineId: routine.id,
            routineName: routine.name,
            day,
          });
        }
      });
    });
    return matches;
  },

  toggleRoutineActive: (id) =>
    set((state) => {
      const newState = {
        routines: state.routines.map((r) =>
          r.id === id ? { ...r, active: !r.active } : r
        ),
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  getActiveRoutines: () => get().routines.filter((r) => r.active),

  getWeeklySchedule: () => {
    const daysOrder = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    const today = daysOrder[new Date().getDay()];
    const schedule = {};

    daysOrder.forEach((day) => {
      schedule[day] = {
        day,
        isToday: day === today,
        workouts: get().getRoutinesByDay(day),
      };
    });

    return schedule;
  },
}));

export const rehydrateRoutines = () => useRoutineStore.setState({ routines: getInitialRoutines() });
